import firebase from 'firebase';
// Initialize Firebase
var config = {
  apiKey: "AIzaSyBfeAW9OcuMrVtdviHKNWcWJicZIGZIpyY",
  authDomain: "menutium-c5be0.firebaseapp.com",
  databaseURL: "https://menutium-c5be0.firebaseio.com",
  projectId: "menutium-c5be0",
  storageBucket: "menutium-c5be0.appspot.com",
  messagingSenderId: "1027958068045"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
 
}

const auth = firebase.auth();

export {auth, firebase};


// WEBPACK FOOTER //
// ./src/firebase.js